<template>
  <div class="cb-mobile-app">
    <div class="cb-mobile-app__img-container">
      <button
        id="open-nav"
        aria-label="Open Navigation"
        @click="handleNavButtonClick"
        class="nav-button nav-button--mobile"
      >
        <img alt src="../assets/icons/menu-icon-white.svg" />
      </button>
      <img alt="ADT Cellbridge Device" src="../assets/images/my-adt-app.png" />
      <div class="cb-mobile-app__img-container__mask"></div>
    </div>
    <div class="cb-mobile-app__container">
      <button
        id="open-nav"
        aria-label="Open Navigation"
        @click="handleNavButtonClick"
        class="nav-button nav-button--desktop"
      >
        <img alt src="../assets/icons/menu-icon-blue.svg" />
      </button>
      <cb-navigation
        v-if="isNavigationOpen"
        :showTroubleshootLink="false"
        class="cb-navigation--desktop"
      ></cb-navigation>
      <div class="cb-mobile-app__container__content">
        <h1 class="cb-heading-5" tabindex="-1" ref="title">{{ title }}</h1>
        <p v-if="screenSize === 'mobile'" class="cb-body-1">
          Unlock the full myADT experience
        </p>
        <p v-else class="cb-body-1">
          Unlock the full myADT experience, <strong>download MyADT app</strong>
        </p>
        <a
          :href="mobileAppURL"
          class="cb-button cb-button--blue mobile-download"
          >Download MyADT app</a
        >
        <div class="cb-mobile-app__container__content__button-container">
          <a href="https://apps.apple.com/us/app/myadt/id860107112?mt=8">
            <img
              alt="Download on the App Store"
              src="../assets/icons/ios-app-store.svg"
            />
          </a>
          <a
            href="https://play.google.com/store/apps/details?id=com.myadt.android&hl=en_US"
          >
            <img
              alt="Get it on Google Play"
              src="../assets/icons/google-play-store.svg"
            />
          </a>
        </div>
        <a @click="trackLinks" class="cb-link" href="https://www.myadt.com/"
          >Go To MyADT</a
        >
      </div>
      <div class="cb-mobile-app__container__content__footer">
        <div class="cb-mobile-app__container__content__divider"></div>
        <a
          @click="trackLinks"
          class="cb-button cb-button--outline-blue"
          href="https://www.myadt.com/"
          >Go To MyADT</a
        >
      </div>
    </div>
    <cb-navigation
      v-if="isNavigationOpen"
      :showTroubleshootLink="false"
      class="cb-navigation--mobile"
    ></cb-navigation>
  </div>
</template>

<script>
/* global gtag */
import { mapState, mapMutations } from 'vuex';
import Navigation from '../components/NavigationModal.vue';

export default {
  data() {
    return {
      mobileAppURL: '',
    };
  },
  beforeMount() {
    function iOS() {
      return (
        [
          'iPad Simulator',
          'iPhone Simulator',
          'iPod Simulator',
          'iPad',
          'iPhone',
          'iPod',
        ].includes(navigator.platform)
        || (navigator.userAgent.includes('Mac') && 'ontouchend' in document)
      );
    }

    if (iOS()) {
      this.mobileAppURL = 'https://apps.apple.com/us/app/myadt/id860107112?mt=8';
    } else {
      this.mobileAppURL = 'https://play.google.com/store/apps/details?id=com.myadt.android&hl=en_US';
    }
  },
  mounted() {
    this.$refs.title.focus();
    document.title = 'CellBridge - Get more from MyADT';
  },
  computed: {
    ...mapState({
      screenSize: (state) => state.screenSize,
      title: (state) => state.downloadMobileAppTitle,
      isNavigationOpen: (state) => state.navigationModal.isOpen,
    }),
  },
  methods: {
    handleNavButtonClick() {
      this.setIsNavigationModalOpen(true);
      gtag('event', 'openNavClick', {
        event_label: 'open navigation',
        event_category: 'mobileApp',
        value: 1,
      });
    },
    trackLinks(evt) {
      gtag('event', 'linkClick', {
        event_label: evt.target.innerHTML.toLowerCase(),
        event_category: 'mobileApp',
        value: 1,
      });
    },
    ...mapMutations(['setIsNavigationModalOpen']),
  },
  beforeRouteLeave(to, from, next) {
    if (
      to.name !== 'Register'
      && to.name !== 'Login'
    ) {
      next(false);
    } else {
      next();
    }
  },
  components: {
    cbNavigation: Navigation,
  },
};
</script>

<style lang="scss" scoped>
.cb-mobile-app {
  background-color: $light-grey;
  box-sizing: border-box;
  min-height: 100vh;
  padding: 20px 20px 40px;

  .nav-button {
    position: absolute;
    border: 0;
    padding: 0;
    top: 20px;
    right: 20px;
    background-color: transparent;
    height: 24px;
    width: 24px;

    &--desktop {
      display: none;
    }

    img {
      height: 100%;
      width: 100%;
    }
  }

  &__img-container {
    position: relative;
    height: 188px;
    display: flex;
    justify-content: center;
    max-width: 562px;
    margin: 0 auto;
    overflow: hidden;
    border-radius: 10px 10px 0 0;
    background-color: $azure;

    & > img {
      height: 100%;
      transform: translateY(70px) scale(1.81);
    }
  }

  &__container {
    position: relative;
    background-color: white;
    box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.05),
      0 8px 44px 0 rgba(0, 0, 0, 0.08);
    padding: 28px 20px 40px;
    border-radius: 0 0 10px 10px;
    max-width: 562px;
    box-sizing: border-box;
    margin: 0 auto;
    text-align: center;

    &__content {
      .cb-heading-5 {
        margin-bottom: 12px;
        padding: 0 15px;
      }

      .cb-body-1 {
        margin-bottom: 28px;
        font-size: 18px;
        line-height: 27px;
      }

      .mobile-download {
        display: block;
        width: 100%;
        margin-bottom: 46px;
      }

      .cb-link {
        display: inline;
      }

      &__footer,
      &__button-container {
        display: none;
      }

      &__divider {
        display: block;
        height: 1px;
        background-color: $light-blue-grey;
      }
    }
  }

  .cb-navigation {
    &--desktop {
      display: none;
    }
  }

  @include desktop {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: unset;
    padding: 20px;
    box-sizing: border-box;

    .nav-button {
      position: absolute;
      border: 0;
      padding: 0;
      top: 20px;
      right: 20px;
      background-color: transparent;
      height: 24px;
      width: 24px;

      &--desktop {
        display: block;
      }

      &--mobile {
        display: none;
      }

      img {
        height: 100%;
        width: 100%;
      }
    }

    &__img-container {
      height: 574px;
      width: 431px;
      position: relative;
      border-radius: 0;
      margin: 0;

      img {
        transform: translateY(19px) scale(0.94);
      }

      &__mask {
        content: '';
        height: 220px;
        width: 430px;
        bottom: 0;
        left: 0;
        position: absolute;
        background-image: linear-gradient(
          180deg,
          rgba(0, 140, 253, 0) 4%,
          #008cfd 72%
        );
        z-index: 5;
      }
    }

    &__container {
      display: flex;
      flex-direction: column;
      height: 574px;
      width: 682px;
      margin: 0;
      max-width: 682px;
      box-sizing: border-box;
      padding: 20px;
      border-radius: 0;

      &__content {
        flex-grow: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        .cb-heading-5 {
          padding: 0 138px;
          font-size: 28px;
          line-height: 38px;
        }

        .cb-body-1 {
          padding: 0 138px;
          margin-bottom: 40px;
        }

        .cb-link,
        .mobile-download {
          display: none;
        }

        &__button-container {
          display: block;
          padding: 20px;
          box-sizing: border-box;
          background: #ffffff;
          box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.05),
            0 8px 44px 0 rgba(0, 0, 0, 0.08);
          border-radius: 10px;

          a {
            &:first-of-type {
              margin-right: 12px;
            }

            &:last-of-type {
              margin-left: 12px;
            }
          }
        }

        &__divider {
          margin-bottom: 20px;
        }

        &__footer {
          display: flex;
          flex-direction: column;

          .cb-button {
            width: fit-content;
            align-self: flex-end;
          }
        }

        &__button-container {
          display: block;
        }
      }
    }

    .cb-navigation {
      &--mobile {
        display: none;
      }
      &--desktop {
        display: block;
      }
    }
  }
}
</style>
